module.exports = __webpack_public_path__ + "img/symbol_12.4879b556.png";